import geoJSON from 'utils/geoJSON/geoJSON'
import ObjectTools from 'utils/objects/objectTools'

const generalConfig = {
  chart: {
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    },
    marginBottom: 30,
    backgroundColor: 'rgba(0,0,0,0)'
  },
  title: {
    text: '',
    floating: true,
    align: 'right',
    x: 1,
    y: 12,
    useHTML: true,
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#717171',
      backgroundColor: '#FFF',
      padding: '5px 10px 5px 10px',
      borderRadius: '0px 0px 0px 10px'
    }
  },
  credits: {
    enabled: true,
    text: '',
    href: 'https://www.orkestra.deusto.es',
    position: {
      y: -10
    },
    style: {
      fontSize: '12px'
    }
  },
  exporting: {
    sourceWidth: 800,
    sourceHeight: 550,
    buttons: {
      contextButton: {
        enabled: false
      }
    },
    allowHTML: true
  },
  tooltip: {
    enabled: true,
    valueSuffix: '',
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    }
  },
  mapNavigation: {
    enabled: true,

    buttonOptions: {
      verticalAlign: 'top',
      alignTo: 'spacingBox'
    }
  },
  colorAxis: {
    tickPixelInterval: 50,
    startOnTick: false,
    endOnTick: false,
    labels: {
      align: 'right',
      x: 30
    },
    reversed: false
  },
  legend: {
    borderWidth: 0,
    padding: 0,
    itemDistance: 2,
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'bottom',
    floating: false
  },

  series: []
}

let selectedRegionConfig = ObjectTools.copyObject(generalConfig)

const chartMapConfig = {
  geoJSON,
  generalConfig,
  selectedRegionConfig
}

export default chartMapConfig



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChart/MapChartConfig.js